import router, { resetRouter } from './router'
import { transRouteData } from '@/store/modules/user'
import store from './store'
// import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken, getAllPermission, getDefaultCur, getRoles } from '@/utils/auth' // , getAllRoles, getRouterArr, getDefaultCur get token from cookie
import getPageTitle from '@/utils/get-page-title'
// import { Loading } from 'element-ui'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist 在白名单重定向中

var getRouter
// const loadingInstance = Loading.service({
//   lock: true,
//   text: 'Loading',
//   spinner: 'el-icon-loading',
//   background: 'rgba(0, 0, 0, 0.7)'
// })
router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()
  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken()
  const role = getRoles()
  // eslint-disable-next-line
  var roles = eval('(' + role + ')')
  if (hasToken && getAllPermission() && getAllPermission()[getDefaultCur()]) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // 00
    } else {
      if (!getRouter) { // 不加这个判断，路由会陷入死循环
        // 刷新
        if (from.path == '/') {
          // console.log(777, getAllPermission()[getDefaultCur()])
          // console.log('生成新路由')
          // 生成新路由
          // if (getAllPermission()) {
          resetRouter()
          getRouter = await transRouteData(getAllPermission()[getDefaultCur()].router)
          router.addRoutes(getRouter)
          store.dispatch('tagsView/delAllViews', null, { root: true })
          if (store.state.permission.routes.length == 0) {
            store.dispatch('permission/setNewRoutes', getRouter)
          }
          next({ ...to, replace: true })

          // } else {
          //   store.dispatch('user/logout')
          //   next(`/login?redirect=${to.path}`)
          //   NProgress.done()
          // }
        } else {
          next()
        }
      } else {
        if (store.state.permission.routes.length == 0) {
          store.dispatch('permission/setNewRoutes', getRouter)
        }
        next()
      }

      // if (Cookies.get('fresh')) {
      //   alert('有刷新cookie, 生成路由中')
      //   resetRouter()
      //   const accessRoutes = transRouteData(getAllPermission()[getDefaultCur()].router)
      //   const newAccessRoutes = await store.dispatch(
      //     'permission/autoGenerateRoutes',
      //     accessRoutes,
      //     { root: true }
      //   )
      //   router.addRoutes(newAccessRoutes)
      //   store.dispatch('tagsView/delAllViews', null, { root: true })
      //   next({ ...to, replace: true })
      //   Cookies.set('fresh', false)
      // } else {
      //   alert('刷新')
      //   Cookies.set('fresh', true)
      //   resetRouter()
      //   const accessRoutes = transRouteData(getAllPermission()[getDefaultCur()].router)
      //   const newAccessRoutes = await store.dispatch(
      //     'permission/autoGenerateRoutes',
      //     accessRoutes,
      //     { root: true }
      //   )
      //   router.addRoutes(newAccessRoutes)
      //   store.dispatch('tagsView/delAllViews', null, { root: true })
      //   next({ ...to, replace: true })
      //   Cookies.set('fresh', false)
      // }

      // if (!routerArr) {
      // } else {
      // }
      // if (hasRoles) {
      // await next()
      // if (store.state.permission.routes.length > 0) {
      //   next(false)
      // } else {
      //   resetRouter()
      //   const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
      //   router.addRoutes(accessRoutes)
      // }
      // } else {
      // try {
      //   // get user info
      //   // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
      //   const { roles } = await store.dispatch('user/getInfo')

      //   // generate accessible routes map based on roles
      //   const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
      //   // dynamically add accessible routes
      //   router.addRoutes(accessRoutes)

      //   // hack method to ensure that addRoutes is complete
      //   // set the replace: true, so the navigation will not leave a history record
      //   next({ ...to, replace: true })
      // } catch (error) {
      //   // remove token and go to login page to re-login
      //   await store.dispatch('user/resetToken')
      //   Message.error(error || 'Has Error')
      //   next(`/login?redirect=${to.path}`)
      //   NProgress.done()
      // }
      // }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done() // 00
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done() // 00
})
